export default function WhoWeAreSection () {
    return (
        <section></section>
    )
}